import { render, staticRenderFns } from "./cart-navbar.vue?vue&type=template&id=cb819562&"
import script from "./cart-navbar.vue.ts?vue&type=script&lang=ts&"
export * from "./cart-navbar.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports